module.exports = __webpack_public_path__ + "static/img/symbol-neofect-colored.1954dd5f.svg";